import React from "react"
import classnames from "classnames"

const ExternalLink = props => {
  return (
    <a
      {...props}
      className={classnames("external-link", props.className)}
      title={props.title || props.children}
      target="_blank"
      rel="noopener"
    ></a>
  )
}

export default ExternalLink
